import React, { useEffect, useState } from 'react';

import { Alert, ConfigService } from '../../services';
import 'react-loading-skeleton/dist/skeleton.css';
import Pagination from '../../components/Pagination';
import { ActivityLogService } from '../../services';
import TableComponent from '../../components/TableComponent';
import SortByFilter from '../../components/listing/SortByFilter';
import NoDataFound from '../../components/NoDataFound';
import SearchInput from '../../components/SearchInput';

const ManageActivityLogs = () => {
  const [page, setPage] = useState(1);
  const [, setTotalPages] = useState(1);
  const [perPage] = useState(10);

  const [isPagination, setPagination] = useState({
    totalPages: 10,
    currentPage: 1,
  });

  const [filterData, setFilterData] = useState({
    perPage: perPage,
    page: 1,
    commonSearch: '',
    sortBy: 'new_to_old',
  });
  const [isLoader, setLoader] = useState(false);
  const [activityLogDetails, setactivityLogDetails] = useState([]);

  useEffect(() => {
    const getActivityLogList = async () => {
      try {
        setLoader(true);
        let activityLogResponse = await ActivityLogService.getActivityLogList(
          filterData.perPage,
          filterData.page,
          filterData.commonSearch,
          filterData.sortBy,
        );

        if (activityLogResponse.status === 'failure') {
          setLoader(false);
          Alert.error(activityLogResponse.message);
          return false;
        }

        setPagination({
          totalPages: activityLogResponse.data.pagination.totalPages,
          currentPage: activityLogResponse.data.pagination.page,
        });
        setactivityLogDetails(activityLogResponse.data.records);
        setTotalPages(activityLogResponse.data.pagination.totalPages);
        setPage(activityLogResponse.data.pagination.page);
        setLoader(false);
      } catch (error) {
        setLoader(false);
        Alert.error(error.message);
        return false;
      }
    };
    getActivityLogList();
  }, [filterData]);

  const searchData = () => {
    const commonSearch = document.getElementById('commonSearch').value;
    const sortBy = document.getElementById('sortBy').value;

    setFilterData({
      perPage: perPage,
      page: page,
      commonSearch: commonSearch,
      sortBy,
    });
  };
  // Pagination
  const handlePagination = (current) => {
    setPagination({ ...isPagination, currentPage: current });
    setFilterData({
      ...filterData,
      page: current,
    });
  };
  // Reset filter
  const resetFilter = () => {
    if (filterData.sortBy !== 'new_to_old' || filterData.commonSearch) {
      setFilterData({
        ...filterData,
        commonSearch: '',
        sortBy: 'new_to_old',
        status: '',
      });
    }
  };
  const sortByOptions = [
    { name: 'Sort By', value: '' },
    { name: 'Latest To Old', value: 'new_to_old' },
    { name: 'Old To Latest', value: 'old_to_new' },
  ];
  const tableConfig = {
    columns: {
      user_name: {
        title: 'User Name',
        render: (data) => {
          return data.user ? data.user.full_name : '';
        },
      },
      event: {
        title: 'Event',
        render: (data) => {
          return data.event;
        },
      },
      description: {
        title: 'Description',
        render: (data) => {
          return data.description;
        },
      },
      activity_date: {
        title: 'Activity Date',
        render: (data) => {
          return ConfigService.dateFormat(data.created_at, true);
        },
      },
    },
    data: activityLogDetails,
  };

  return (
    <div className="">
      <div className="grid grid-cols-2 mb-4">
        <h4 className="">Activity Logs</h4>
        <div className="flex justify-end items-center"></div>
      </div>

      <div className="w-full bg-brandGray px-4 md:px-5 py-4 rounded-xl">
        <div className="md:grid md:grid-cols-3 mb-2 md:mb-0 ">
          <div className=""></div>
          <div className="md:flex items-center md:justify-end gap-3 md:col-span-2">
            <SortByFilter
              value={filterData.sortBy}
              dropdownList={sortByOptions}
              filterData={filterData}
              setFilterData={setFilterData}
              setPage={setPage}
              fieldName="sortBy"
            />
            <div className="flex sm:inline-flex relative mb-2 sm:mb-0">
              <SearchInput
                name="commonSearch"
                id="commonSearch"
                value={filterData?.commonSearch}
                placeholder="Search By User Name / Event"
                onChange={() => {
                  setPage(1);
                  searchData();
                }}
              />
            </div>
            <p
              className="text-blue-700 rounded bg-blue-500 ml-2 lg:ml-0 bg-opacity-5 text-center font-medium text-sm inline-block cursor-pointer h-[42px] py-3 px-2 min-w-[100px]"
              onClick={() => resetFilter()}
            >
              Clear filters
            </p>
          </div>
        </div>

        <div className="flex flex-col relative overflow-x-auto w-full">
          <TableComponent
            tableConfig={tableConfig}
            isListLoader={isLoader}
            isList={activityLogDetails}
          />
          {activityLogDetails &&
            activityLogDetails.length > 0 &&
            isLoader === false && (
              <Pagination
                total={isPagination.totalPages}
                current={isPagination.currentPage}
                pagination={(crPage) => handlePagination(crPage)}
              />
            )}
          {activityLogDetails &&
            activityLogDetails.length === 0 &&
            isLoader === false && (
              <>
                <NoDataFound />
              </>
            )}
        </div>
      </div>
    </div>
  );
};

export default ManageActivityLogs;
